import { toast } from "sonner";
import { Inbox, Mail, Phone } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageHeader, EmptyState, Loading, StatusBadge } from "@/components/common";
import { api, useFetch, errMsg, fmtDate } from "@/lib/api";

const STAGES = [["new", "New"], ["contacted", "Contacted"], ["viewing_booked", "Viewing booked"], ["closed", "Closed"]];

export default function Enquiries() {
  const { data, setData } = useFetch("/biz/enquiries");
  const move = async (e, status) => {
    try { await api.patch(`/biz/enquiries/${e.id}`, { status }); setData((d) => d.map((x) => (x.id === e.id ? { ...x, status } : x))); toast.success("Enquiry updated"); } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div data-testid="enquiries-page">
      <PageHeader eyebrow="Leads" title="Enquiries" subtitle="Messages from people viewing your listings on your public property page." />
      {!data ? <Loading /> : data.length === 0 ? <EmptyState icon={Inbox} title="No enquiries yet" text="Publish a listing and share your property page." /> : (
        <div className="space-y-3">
          {data.map((e) => (
            <div key={e.id} className="panel flex flex-col md:flex-row md:items-start justify-between gap-4" data-testid={`enquiry-${e.id}`}>
              <div className="min-w-0">
                <div className="flex items-center gap-2"><span className="font-semibold">{e.name}</span>{e.status === "new" && <StatusBadge status="due" label="New" />}</div>
                <div className="text-xs text-slate-500 mt-0.5">{e.listing_title} · {fmtDate(e.created_at)}</div>
                <p className="text-sm mt-2 whitespace-pre-wrap">{e.message}</p>
                <div className="flex flex-wrap gap-4 mt-2 text-sm text-slate-600">
                  <a href={`mailto:${e.email}`} className="flex items-center gap-1 hover:text-slate-900"><Mail className="w-4 h-4" />{e.email}</a>
                  {e.phone && <a href={`tel:${e.phone}`} className="flex items-center gap-1"><Phone className="w-4 h-4" />{e.phone}</a>}
                </div>
              </div>
              <Select value={e.status} onValueChange={(v) => move(e, v)}>
                <SelectTrigger className="w-44" data-testid={`enquiry-status-${e.id}`}><SelectValue /></SelectTrigger>
                <SelectContent>{STAGES.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
              </Select>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
